module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_3009.ba303f81.png";